module.exports = __webpack_public_path__ + "img/开场·雨天看剧 v2_1.52a7c46f.png";